import React, { useState, useEffect } from 'react';
import ChangePassword from './ChangePassword';

const btn = {padding:'8px 16px',borderRadius:'6px',border:'none',cursor:'pointer',fontWeight:'500',fontSize:'14px'};
const inp = {width:'100%',padding:'8px 12px',border:'1px solid #e2e8f0',borderRadius:'6px',fontSize:'14px',boxSizing:'border-box',marginBottom:'10px'};

export default function Manager2Dashboard({ user, onLogout }) {
  const [tab, setTab] = useState('cases');
  const [cases, setCases] = useState([]);
  const [sel, setSel] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [msg, setMsg] = useState('');
  const [showNewCase, setShowNewCase] = useState(false);
  const [caseTab, setCaseTab] = useState('pending');
  const [caseSearch, setCaseSearch] = useState('');
  const m2MatchSearch = c => { const q = caseSearch.trim().toLowerCase(); if (!q) return true; return [c.case_number, c.subscriber_name, c.subscriber_mobile, c.group_code, c.ticket_no].some(v => (v == null ? '' : String(v)).toLowerCase().includes(q)); };
  const [documents, setDocuments] = useState([]);
  const [docComments, setDocComments] = useState({});
  const [offices, setOffices] = useState([]);
  const [detailTab, setDetailTab] = useState('customers');
  const [m2ForwardNote, setM2ForwardNote] = useState('');
  const [showRejectAll, setShowRejectAll] = useState(false);
  const [rejectAllReason, setRejectAllReason] = useState('');
  const [rejectingAll, setRejectingAll] = useState(false);
  const [caseNotes, setCaseNotes] = useState([]);
  const [showChangePw, setShowChangePw] = useState(false);

  const [nc, setNc] = useState({
    group_code:'', ticket_no:'', subscriber_name:'', subscriber_mobile:'', chit_value:'',
    months:'', auction_no:'', bid_amount:'', prize_amount:'',
    future_liability:'', auction_date:'', manager_notes:'', office_id:''
  });

  const getHeaders = () => ({'Content-Type':'application/json','Authorization':`Bearer ${localStorage.getItem('token')}`});

  const calcFutureLiability = (chit_value, months, auction_no) => {
    const cv = parseFloat(chit_value);
    const m = parseFloat(months);
    const an = parseFloat(auction_no);
    if (cv > 0 && m > 0 && an > 0 && m >= an) {
      return ((cv / m) * (m - an)).toFixed(0);
    }
    return '';
  };

  const updateNc = (field, value) => {
    const updated = {...nc, [field]: value};
    if (['chit_value','bid_amount'].includes(field)) {
      const cv = parseFloat(field==='chit_value' ? value : nc.chit_value) || 0;
      const ba = parseFloat(field==='bid_amount' ? value : nc.bid_amount) || 0;
      if (cv > 0 && ba > 0) updated.prize_amount = (cv - ba).toString();
    }
    if (['chit_value','months','auction_no'].includes(field)) {
      updated.future_liability = calcFutureLiability(
        field==='chit_value' ? value : nc.chit_value,
        field==='months' ? value : nc.months,
        field==='auction_no' ? value : nc.auction_no
      );
    }
    setNc(updated);
  };

  const fetchCases = async () => {
    const r = await fetch('/api/cases', {headers:getHeaders()});
    const d = await r.json();
    setCases(d.cases || []);
  };

  const fetchCustomers = async (id) => {
    const r = await fetch(`/api/customers/${id}`, {headers:getHeaders()});
    const d = await r.json();
    setCustomers(d.customers || []);
  };

  const fetchDocuments = async (id) => {
    const r = await fetch(`/api/documents/${id}`, {headers:getHeaders()});
    const d = await r.json();
    setDocuments(d.documents || []);
  };

  const fetchOffices = async () => {
    const r = await fetch('/api/users/offices', {headers:getHeaders()});
    const d = await r.json();
    setOffices(d.offices || []);
  };

  useEffect(() => { fetchCases(); fetchOffices(); }, []);

  const createCase = async () => {
    if (!nc.group_code || !nc.ticket_no || !nc.subscriber_name || !nc.subscriber_mobile || !nc.chit_value || !nc.months || !nc.auction_no || !nc.bid_amount || !nc.prize_amount || !nc.auction_date || !nc.office_id) {
      setMsg('Please fill all required fields'); return;
    }
    if (parseFloat(nc.auction_no) > parseFloat(nc.months)) {
      setMsg('Auction No. cannot be more than chit months'); return;
    }
    const r = await fetch('/api/cases', {method:'POST',headers:getHeaders(),body:JSON.stringify(nc)});
    const d = await r.json();
    if (d.case_id) {
      setMsg('SB created! Case No: '+d.case_number);
      fetchCases();
      setShowNewCase(false);
      setNc({group_code:'',ticket_no:'',subscriber_name:'',subscriber_mobile:'',chit_value:'',months:'',auction_no:'',bid_amount:'',prize_amount:'',future_liability:'',auction_date:'',manager_notes:'',office_id:''});
    } else setMsg(d.message || 'Error');
  };

  const fetchNotes = async (id) => {
    const r = await fetch(`/api/cases/${id}/notes`, {headers:getHeaders()});
    const d = await r.json();
    setCaseNotes(d.notes || []);
  };
  const openCase = (c) => { setSel(c); fetchCustomers(c.id); fetchDocuments(c.id); fetchNotes(c.id); setTab('detail'); setDetailTab('customers'); };

  const approveDoc = async (docId, action) => {
    const r = await fetch(`/api/documents/approve/${docId}`, {
      method:'POST', headers:getHeaders(),
      body: JSON.stringify({action, comments: docComments[docId]||''})
    });
    const d = await r.json();
    setMsg(d.message || 'Done');
    fetchDocuments(sel.id);
  };
  const rejectAllDocs = async () => {
    if (!rejectAllReason.trim()) { setMsg('Reason is mandatory when rejecting all documents'); return; }
    setRejectingAll(true);
    try {
      const r = await fetch('/api/documents/bulk-action', {
        method:'POST', headers:getHeaders(),
        body: JSON.stringify({ document_ids: documents.map(d=>d.id), action:'rejected', comments: rejectAllReason.trim() })
      });
      const d = await r.json();
      if (d.success) {
        setMsg('Case sent back to Employee for full correction');
        setShowRejectAll(false);
        setRejectAllReason('');
        setTab('cases');
        fetchCases();
      } else setMsg(d.message || 'Error');
    } catch { setMsg('Network error'); }
    finally { setRejectingAll(false); }
  };


  const forwardToDirector = async () => {
    const r = await fetch(`/api/documents/${sel.id}/forward`, {
      method:'POST', headers:{...getHeaders(),'Content-Type':'application/json'},
      body: JSON.stringify({notes: m2ForwardNote||''})
    });
    const d = await r.json();
    setMsg(d.message || 'Forwarded to Director');
    setM2ForwardNote('');
    setTab('cases');
    fetchCases();
  };


  const currentWithName = (c) => {
    const status = c.status;
    if (['case_created','director_approved','sent_back_for_correction','additional_docs_required'].includes(status)) return c.employee_name || '';
    if (status === 'doc_under_review') return c.manager1_name || '';
    if (status === 'm1_reviewed') return ''; // Manager2 themselves
    if (['m2_reviewed','d1_doc_approved'].includes(status)) return c.d1_approver_name || 'Director';
    if (status === 'both_dirs_approved') return c.d2_approver_name || 'Director 2';
    return '';
  };
  const currentWith = (status) => {
    const map = {
      case_created:              {label:'Employee',             color:'#3182ce'},
      doc_under_review:          {label:'Manager 1',            color:'#d69e2e'},
      m1_reviewed:               {label:'Manager 2',            color:'#744210'},
      m2_reviewed:               {label:'Director',             color:'#553c9a'},
      director_approved:         {label:'Employee (Docs)',       color:'#3182ce'},
      sent_back_for_correction:  {label:'Employee (Correction)',color:'#e53e3e'},
      additional_docs_required:  {label:'Employee (Add Docs)',  color:'#e53e3e'},
      d1_doc_approved:           {label:'Director 2',           color:'#553c9a'},
      both_dirs_approved:        {label:'Accounts',             color:'#276749'},
      payment_scheduled:         {label:'Accounts',             color:'#276749'},
      paid:                      {label:'Completed',            color:'#38a169'},
    };
    return map[status] || {label:status, color:'#718096'};
  };

  const sc = (s) => ({draft:'#718096',case_created:'#d69e2e',doc_under_review:'#d69e2e',verified_under_process:'#3182ce',approved:'#38a169',rejected:'#e53e3e',sent_back_for_correction:'#dd6b20'}[s]||'#718096');

  const docStatusColor = (s) => ({
    pending:'#718096', uploaded:'#3182ce',
    m1_approved:'#38a169', m1_rejected:'#e53e3e', m1_resubmit:'#dd6b20',
    m2_approved:'#2f855a', m2_rejected:'#c53030', m2_resubmit:'#c05621',
    d1_approved:'#1a365d', d2_approved:'#1a365d'
  }[s]||'#718096');

  const pendingDocs = documents.filter(d => ['m1_approved','uploaded'].includes(d.status));
  const allDocs = documents;

  return (
    <div style={{minHeight:'100vh',background:'#f7fafc'}}>
      <div style={{background:'#744210',color:'white',padding:'0 24px',display:'flex',alignItems:'center',justifyContent:'space-between',height:'60px'}}>
        <h1 style={{margin:0,fontSize:'20px',fontWeight:'bold'}}>AH Chits – Manager</h1>
        <div style={{display:'flex',alignItems:'center',gap:'16px'}}>
          <span style={{fontSize:'14px',opacity:0.8}}>{user.name||user.mobile}</span>
          <button onClick={()=>setShowChangePw(true)} style={{...btn,background:'rgba(255,255,255,0.2)',color:'white',padding:'6px 14px'}}>🔒 Change Password</button>
          <button onClick={onLogout} style={{...btn,background:'rgba(255,255,255,0.2)',color:'white',padding:'6px 14px'}}>Logout</button>
        </div>
      </div>

      {tab !== 'detail' && (
        <div style={{background:'white',borderBottom:'1px solid #e2e8f0',padding:'0 24px'}}>
          <button onClick={()=>setTab('cases')} style={{...btn,background:'none',color:tab==='cases'?'#744210':'#718096',borderBottom:tab==='cases'?'2px solid #744210':'2px solid transparent',borderRadius:0,padding:'14px 16px'}}>SB List</button>
        </div>
      )}

      <div style={{padding:'24px',maxWidth:'1100px',margin:'0 auto'}}>
        {msg && <div style={{background:'#fffff0',color:'#744210',padding:'10px 16px',borderRadius:'8px',marginBottom:'16px',border:'1px solid #f6e05e'}}>{msg} <button onClick={()=>setMsg('')} style={{float:'right',background:'none',border:'none',cursor:'pointer'}}>✕</button></div>}

        {tab === 'cases' && (
          <div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
              <h2 style={{margin:0,color:'#1a365d'}}>SB List</h2><input value={caseSearch} onChange={e=>setCaseSearch(e.target.value)} placeholder="Search case no, name, mobile, group, ticket" style={{flex:1,maxWidth:'380px',margin:'0 16px',padding:'8px 12px',border:'1px solid #cbd5e0',borderRadius:'6px',fontSize:'13px'}} />
              <div style={{display:'flex',gap:'4px',background:'#fff',padding:'4px',borderRadius:'8px',boxShadow:'0 1px 3px rgba(0,0,0,0.06)'}}>
                <button onClick={()=>setCaseTab('pending')} style={{padding:'6px 16px',borderRadius:'6px',border:'none',background:caseTab==='pending'?'#1d4ed8':'transparent',color:caseTab==='pending'?'#fff':'#6b7280',cursor:'pointer',fontWeight:'600',fontSize:'13px'}}>Pending ({cases.filter(c=>c.status!=='paid').length})</button>
                <button onClick={()=>setCaseTab('paid')} style={{padding:'6px 16px',borderRadius:'6px',border:'none',background:caseTab==='paid'?'#16a34a':'transparent',color:caseTab==='paid'?'#fff':'#6b7280',cursor:'pointer',fontWeight:'600',fontSize:'13px'}}>Paid ({cases.filter(c=>c.status==='paid').length})</button>
              </div>
            </div>
              {user.can_create_cases!==0 && <button onClick={()=>setShowNewCase(!showNewCase)} style={{...btn,background:'#744210',color:'white'}}>+ New SB</button>}
            </div>

            {showNewCase && (
              <div style={{background:'white',padding:'20px',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.1)',marginBottom:'16px'}}>
                <h3 style={{margin:'0 0 16px'}}>New Successful Bidder (SB)</h3>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'0 12px'}}>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Group Code *</label><input style={inp} value={nc.group_code} onChange={e=>updateNc('group_code',e.target.value)} /></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Ticket No *</label><input style={inp} value={nc.ticket_no} onChange={e=>updateNc('ticket_no',e.target.value)} /></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Subscriber Name *</label><input style={inp} value={nc.subscriber_name} onChange={e=>updateNc('subscriber_name',e.target.value)} /></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Subscriber Mobile *</label><input style={inp} value={nc.subscriber_mobile} onChange={e=>updateNc('subscriber_mobile',e.target.value)} placeholder="10 digit mobile" /></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Chit Value (₹) *</label><input style={inp} type="number" value={nc.chit_value} onChange={e=>updateNc('chit_value',e.target.value)} /></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Months *</label><input style={inp} type="number" value={nc.months} onChange={e=>updateNc('months',e.target.value)} placeholder="e.g. 25" /></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Auction No *</label><input style={inp} type="number" value={nc.auction_no} onChange={e=>updateNc('auction_no',e.target.value)} /></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Bid Amount (₹) *</label><input style={inp} type="number" value={nc.bid_amount} onChange={e=>updateNc('bid_amount',e.target.value)} /></div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Prize Amount (₹) — Auto Calculated</label><input style={{...inp,background:'#f0fff4',color:'#276749',fontWeight:'600'}} type="number" value={nc.prize_amount} readOnly /></div>
                  <div>
                    <label style={{fontSize:'12px',color:'#718096'}}>Future Liability (₹) — Auto Calculated</label>
                    <input style={{...inp,background:'#f0fff4',fontWeight:'600',color:'#276749'}} type="number" value={nc.future_liability} readOnly placeholder="Auto calculated" />
                    {nc.chit_value && nc.months && nc.auction_no && (
                      <div style={{fontSize:'11px',color:'#718096',marginTop:'-8px',marginBottom:'8px'}}>
                        = (₹{Number(nc.chit_value).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})} ÷ {nc.months}) × ({nc.months} − {nc.auction_no})
                      </div>
                    )}
                  </div>
                  <div><label style={{fontSize:'12px',color:'#718096'}}>Auction Date *</label><input style={inp} type="date" value={nc.auction_date} onChange={e=>updateNc('auction_date',e.target.value)} /></div>
                  <div style={{gridColumn:'span 2'}}><label style={{fontSize:'12px',color:'#718096'}}>Office *</label>
                    <select style={inp} value={nc.office_id} onChange={e=>updateNc('office_id',e.target.value)}>
                      <option value="">Select Office</option>
                      {offices.map(o=><option key={o.id} value={o.id}>{o.office_name}</option>)}
                    </select>
                  </div>
                  <div style={{gridColumn:'span 3'}}><label style={{fontSize:'12px',color:'#718096'}}>Notes</label><input style={inp} value={nc.manager_notes} onChange={e=>updateNc('manager_notes',e.target.value)} /></div>
                </div>
                <div style={{display:'flex',gap:'8px'}}>
                  <button onClick={createCase} style={{...btn,background:'#38a169',color:'white'}}>Create SB</button>
                  <button onClick={()=>setShowNewCase(false)} style={{...btn,background:'#e2e8f0',color:'#4a5568'}}>Cancel</button>
                </div>
              </div>
            )}

            <div style={{background:'white',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',overflow:'hidden'}}>
              <table style={{width:'100%',borderCollapse:'collapse'}}>
                <thead><tr style={{background:'#edf2f7'}}>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Case No</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Subscriber</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Chit Value</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Location</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Prize Amount</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Status</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Payment Date</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Currently With</th>
                  <th style={{padding:'12px 16px',textAlign:'left',fontSize:'13px',color:'#4a5568'}}>Action</th>
                </tr></thead>
                <tbody>
                  {cases.filter(c=>caseTab==='paid'?c.status==='paid':c.status!=='paid').filter(m2MatchSearch).map((c,i)=>(
                    <tr key={c.id} style={{borderTop:'1px solid #e2e8f0',background:i%2===0?'white':'#f7fafc'}}>
                      <td style={{padding:'12px 16px',fontWeight:'600',color:'#2b6cb0'}}>{c.case_number}{c.pending_review_count>0&&<div style={{marginTop:'3px'}}><span style={{background:'#fefcbf',color:'#92400e',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:'700'}}>📋 {c.pending_review_count} pending review</span></div>}{c.needs_attention_count>0&&<div style={{marginTop:'3px'}}><span style={{background:'#fed7d7',color:'#c53030',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:'700'}}>⚠️ {c.needs_attention_count} need attention</span></div>}</td>
                      <td style={{padding:'12px 16px'}}>{c.subscriber_name||'–'}</td>
                      <td style={{padding:'12px 16px'}}>₹{Number(c.chit_value||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})}</td>
                      <td style={{padding:'12px 16px',fontSize:'13px',color:'#4a5568'}}>{c.office_name||'–'}</td>
                      <td style={{padding:'12px 16px'}}>₹{Number(c.prize_amount||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})}</td>
                      <td style={{padding:'12px 16px'}}><span style={{background:sc(c.status)+'20',color:sc(c.status),padding:'2px 8px',borderRadius:'12px',fontSize:'12px',fontWeight:'600'}}>{c.status}</span></td>
                      <td style={{padding:'12px 16px',fontSize:'12px',color:c.scheduled_date?'#276749':'#a0aec0',fontWeight:c.scheduled_date?'600':'400'}}>{c.scheduled_date?'📅 '+new Date(c.scheduled_date).toLocaleDateString('en-IN', {timeZone:'Asia/Kolkata'}):'–'}</td>
                      <td style={{padding:'12px 16px'}}><span style={{background:currentWith(c.status).color+'20',color:currentWith(c.status).color,padding:'2px 10px',borderRadius:'12px',fontSize:'12px',fontWeight:'600'}}>📍 {currentWith(c.status).label}</span>{currentWithName(c)&&<div style={{fontSize:'11px',color:'#718096',marginTop:'2px'}}>👤 {currentWithName(c)}</div>}</td>
                      <td style={{padding:'12px 16px'}}><button onClick={()=>openCase(c)} style={{...btn,background:'#ebf8ff',color:'#2b6cb0',padding:'4px 12px',fontSize:'12px'}}>Open</button></td>
                    </tr>
                  ))}
                  {cases.filter(c=>caseTab==='paid'?c.status==='paid':c.status!=='paid').filter(m2MatchSearch).length===0 && <tr><td colSpan="8" style={{padding:'24px',textAlign:'center',color:'#a0aec0'}}>No SB cases found</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {tab === 'detail' && sel && (
          <div>
            <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'20px',flexWrap:'wrap'}}>
              <button onClick={()=>setTab('cases')} style={{...btn,background:'#e2e8f0',color:'#4a5568'}}>← Back</button>
              <h2 style={{margin:0,color:'#1a365d'}}>SB: {sel.case_number}</h2>
              <span style={{background:sc(sel.status)+'20',color:sc(sel.status),padding:'4px 12px',borderRadius:'12px',fontSize:'13px',fontWeight:'600'}}>{sel.status}</span>
              {['both_dirs_approved','payment_scheduled','paid'].includes(sel.status) && (
                <button onClick={async(e)=>{
                  const btn2=e.target;
                  btn2.textContent='⏳ Generating...';
                  btn2.disabled=true;
                  try{
                    setMsg('Generating PDF... please wait');
                    const r=await fetch(`/api/cases/${sel.id}/generate-pdf`,{headers:getHeaders()});
                    if(!r.ok){const er=await r.json();setMsg(er.message||'PDF failed');return;}
                    const blob=await r.blob();
                    const url=URL.createObjectURL(blob);
                    const a=document.createElement('a');
                    a.href=url;
                    a.download=`AH-Case-${sel.case_number}.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                    setMsg('PDF downloaded successfully!');
                  }catch(err){setMsg('PDF download failed: '+err.message);}
                  finally{btn2.textContent='📄 Download PDF';btn2.disabled=false;}
                }} style={{...btn,background:'#e53e3e',color:'white',padding:'6px 16px',fontSize:'13px',marginLeft:'auto'}}>
                  📄 Download PDF
                </button>
              )}
            </div>

            <div style={{background:'white',padding:'20px',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',marginBottom:'16px'}}>
              <h3 style={{margin:'0 0 16px',color:'#2d3748'}}>SB Details</h3>
              <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'16px'}}>
                {[
                  ['Subscriber',sel.subscriber_name],
                  ['Chit Value','₹'+Number(sel.chit_value||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                  ['Months',sel.months||'–'],
                  ['Auction No',sel.auction_no],
                  ['Ticket No',sel.ticket_no],
                  ['Bid Amount','₹'+Number(sel.bid_amount||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                  ['Prize Amount','₹'+Number(sel.prize_amount||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                  ['Future Liability','₹'+Number(sel.future_liability||0).toLocaleString('en-IN', {timeZone:'Asia/Kolkata'})],
                  ['Auction Date',sel.auction_date?new Date(sel.auction_date).toLocaleDateString('en-IN', {timeZone:'Asia/Kolkata'}):'–'],
                  ['Group Code',sel.group_code||'–']
                ].map(([l,v])=>(
                  <div key={l}><div style={{fontSize:'12px',color:'#718096',marginBottom:'4px'}}>{l}</div><div style={{fontWeight:'600',color:'#2d3748'}}>{v||'–'}</div></div>
                ))}
              </div>
            </div>

            {caseNotes.length > 0 && (
              <div style={{background:'#fffbeb',border:'1px solid #fcd34d',borderRadius:'8px',padding:'14px 18px',marginBottom:'16px'}}>
                <div style={{fontWeight:'700',color:'#92400e',marginBottom:'10px',fontSize:'14px'}}>📋 Approval Notes</div>
                {caseNotes.map((n,i)=>(
                  <div key={i} style={{borderLeft:'3px solid #fcd34d',paddingLeft:'10px',marginBottom:'8px'}}>
                    <div style={{fontSize:'12px',color:'#718096',marginBottom:'2px'}}>
                      <strong>{n.approver_name}</strong> ({n.approver_role}) — {n.action} — {new Date(n.actioned_at).toLocaleDateString('en-IN', {timeZone:'Asia/Kolkata'})}
                    </div>
                    <div style={{fontSize:'13px',color:'#2d3748'}}>{n.comments}</div>
                  </div>
                ))}
              </div>
            )}

            <div style={{background:'white',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',overflow:'hidden'}}>
              <div style={{borderBottom:'1px solid #e2e8f0',padding:'0 20px',display:'flex'}}>
                <button onClick={()=>setDetailTab('customers')} style={{...btn,background:'none',color:detailTab==='customers'?'#744210':'#718096',borderBottom:detailTab==='customers'?'2px solid #744210':'2px solid transparent',borderRadius:0,padding:'14px 16px'}}>
                  Subscriber & Sureties ({customers.length})
                </button>
                <button onClick={()=>setDetailTab('documents')} style={{...btn,background:'none',color:detailTab==='documents'?'#744210':'#718096',borderBottom:detailTab==='documents'?'2px solid #744210':'2px solid transparent',borderRadius:0,padding:'14px 16px'}}>
                  Documents ({allDocs.length}) {pendingDocs.length > 0 && <span style={{background:'#e53e3e',color:'white',borderRadius:'10px',padding:'1px 7px',fontSize:'11px',marginLeft:'6px'}}>{pendingDocs.length}</span>}
                </button>
              </div>

              <div style={{padding:'20px'}}>
                {detailTab === 'customers' && (
                  <div>
                    {customers.length === 0 ? (
                      <p style={{color:'#a0aec0',textAlign:'center',padding:'20px'}}>No subscriber or sureties added yet.</p>
                    ) : customers.map(cu => (
                      <div key={cu.id} style={{border:'1px solid #e2e8f0',borderRadius:'10px',padding:'16px',marginBottom:'12px',background:cu.type==='subscriber'?'#f0fff4':'white'}}>
                        <div style={{display:'flex',justifyContent:'space-between',marginBottom:'10px',flexWrap:'wrap',gap:'6px'}}>
                          <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                            <span style={{fontWeight:'700',fontSize:'15px',color:'#2d3748'}}>{cu.full_name}</span>
                            <span style={{background:'#ebf8ff',color:'#2b6cb0',padding:'2px 8px',borderRadius:'12px',fontSize:'11px',fontWeight:'600'}}>{cu.type}</span>
                            {cu.surety_type&&<span style={{background:'#faf5ff',color:'#553c9a',padding:'2px 8px',borderRadius:'12px',fontSize:'11px',fontWeight:'600'}}>{cu.surety_type}</span>}
                          </div>
                          <span style={{fontSize:'13px',color:'#718096'}}>{cu.mobile}</span>
                        </div>
                        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(160px,1fr))',gap:'8px',fontSize:'13px'}}>
                          <div><span style={{color:'#718096'}}>Aadhaar: </span><strong>{cu.aadhaar_number||'–'}</strong></div>
                          <div><span style={{color:'#718096'}}>PAN: </span><strong>{cu.pan_number||'–'}</strong></div>
                          <div><span style={{color:'#718096'}}>Employment: </span><strong>{cu.employment_type||'–'}</strong></div>
                          {[['res','Res',cu.res_address,cu.res_location_url],['office','Office',cu.office_address,cu.office_location_url],['perm','Perm',cu.perm_address,cu.perm_location_url]].map(([key,label,addr,mapUrl])=>addr?(
                            <div key={label} style={{gridColumn:'span 2',display:'flex',alignItems:'flex-start',gap:'10px',marginBottom:'6px'}}>
                              <div style={{flex:1}}>
                                <span style={{color:'#718096'}}>{label} Address: </span>{addr}
                                {mapUrl&&<a href={mapUrl} target='_blank' rel='noreferrer' style={{marginLeft:'8px',color:'#2b6cb0',fontSize:'12px'}}>📍 Map</a>}
                              </div>
                              {documents.filter(d=>d.customer_id===cu.id&&d.doc_type===(key==='res'?'res_photo':key==='office'?'office_photo':'perm_photo')).slice(-1).map(img=>(
                                <a key={img.id} href={`/api/documents/file/${img.id}?token=${localStorage.getItem('token')}`} target='_blank' rel='noreferrer'>
                                  <img src={`/api/documents/file/${img.id}?token=${localStorage.getItem('token')}`} alt={label+' location'} style={{width:'80px',height:'60px',objectFit:'cover',borderRadius:'6px',border:'1px solid #e2e8f0'}} />
                                </a>
                              ))}
                            </div>
                          ):null)}
                        </div>
                        {cu.notes&&<div style={{marginTop:'8px',fontSize:'12px',background:'#fffff0',padding:'6px 10px',borderRadius:'6px',color:'#744210',borderLeft:'3px solid #f6e05e'}}>📝 {cu.notes}</div>}
                      </div>
                    ))}
                  </div>
                )}

                {detailTab === 'documents' && (
                  <div>
                    <h3 style={{margin:'0 0 16px',color:'#2d3748'}}>Document Approval — Person by Person</h3>
                    {pendingDocs.length > 0 && (
                      <div style={{background:'#fffbeb',border:'1px solid #f6e05e',borderRadius:'8px',padding:'12px 16px',marginBottom:'16px'}}>
                        <strong style={{color:'#744210'}}>⏳ {pendingDocs.length} document(s) waiting for your approval</strong>
                      </div>
                    )}
                    {allDocs.length === 0 ? (
                      <p style={{color:'#a0aec0',textAlign:'center',padding:'20px'}}>No documents uploaded yet.</p>
                    ) : (
                      <div>
                        {customers.map(cu => {
                          const cuDocs = allDocs.filter(d => d.customer_id === cu.id);
                          if (cuDocs.length === 0) return null;
                          const approved = cuDocs.filter(d=>d.status==='m2_approved').length;
                          return (
                            <div key={cu.id} style={{background:'white',borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.08)',marginBottom:'16px',overflow:'hidden'}}>
                              <div style={{background:'#744210',color:'white',padding:'12px 20px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                <div>
                                  <span style={{fontWeight:'700',fontSize:'15px'}}>{cu.full_name}</span>
                                  <span style={{background:'rgba(255,255,255,0.2)',padding:'2px 10px',borderRadius:'12px',fontSize:'12px',marginLeft:'10px'}}>{cu.type}</span>
                                </div>
                                <span style={{fontSize:'13px',opacity:0.9}}>{approved}/{cuDocs.length} approved</span>
                              </div>
                              <div>
                                {cuDocs.map((doc,i) => {
                                  const needsAction = ['m1_approved','uploaded'].includes(doc.status);
                                  const locked = ['m2_approved','d1_approved','d2_approved','d1_rejected','d2_rejected'].includes(doc.status);
                                  return (
                                    <div key={doc.id} style={{padding:'14px 20px',borderBottom:'1px solid #f0f0f0',background:i%2===0?'white':'#fafafa',display:'flex',alignItems:'center',gap:'12px',flexWrap:'wrap'}}>
                                      <div style={{flex:'1',minWidth:'180px'}}>
                                        <div style={{fontWeight:'600',color:'#2d3748',fontSize:'14px'}}>{doc.doc_type}</div>
                                        <div style={{fontSize:'12px',color:'#718096',marginTop:'2px'}}>{doc.file_name||'—'}</div>
                                      </div>
                                      <span style={{background:docStatusColor(doc.status)+'20',color:docStatusColor(doc.status),padding:'3px 10px',borderRadius:'12px',fontSize:'12px',fontWeight:'600',minWidth:'90px',textAlign:'center'}}>{doc.status||'pending'}</span>
                                      <a href={`/api/documents/file/${doc.id}?token=${localStorage.getItem('token')}`} target="_blank" rel="noreferrer" style={{...btn,background:'#ebf8ff',color:'#2b6cb0',padding:'5px 12px',fontSize:'12px',textDecoration:'none'}}>👁 View</a>
                                      {needsAction && (
                                        <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                          <input placeholder="Comments" value={docComments[doc.id]||''} onChange={e=>setDocComments({...docComments,[doc.id]:e.target.value})} style={{padding:'5px 8px',border:'1px solid #e2e8f0',borderRadius:'4px',fontSize:'12px',width:'140px'}} />
                                          <button onClick={()=>approveDoc(doc.id,'approved')} style={{...btn,background:'#c6f6d5',color:'#276749',padding:'5px 10px',fontSize:'12px'}}>✓ Approve</button>
                                          <button onClick={()=>approveDoc(doc.id,'rejected')} style={{...btn,background:'#fed7d7',color:'#c53030',padding:'5px 10px',fontSize:'12px'}}>✗ Reject</button>
                                          <button onClick={()=>approveDoc(doc.id,'resubmit_requested')} style={{...btn,background:'#fefcbf',color:'#744210',padding:'5px 10px',fontSize:'12px'}}>↩ Resubmit</button>
                                        </div>
                                      )}
                                      {locked && <span style={{fontSize:'12px',color:'#276749'}}>🔒 Locked</span>}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        })}
                        {/* Forward to Director button */}
                        <div style={{marginTop:'20px'}}>
                          {!['m2_reviewed','d1_doc_approved','both_dirs_approved','payment_scheduled','paid'].includes(sel.status) && (
                            <div style={{marginBottom:'12px'}}>
                              <label style={{fontSize:'12px',color:'#374151',fontWeight:'600',display:'block',marginBottom:'6px'}}>Notes for Director (mandatory) *</label>
                              <textarea value={m2ForwardNote||''} onChange={e=>setM2ForwardNote(e.target.value)} placeholder="Explain what was reviewed and any observations before forwarding to Director..." style={{width:'100%',padding:'8px',border:'1px solid #e2e8f0',borderRadius:'6px',fontSize:'13px',height:'70px',resize:'vertical',boxSizing:'border-box'}} />
                              {!m2ForwardNote.trim() && <div style={{fontSize:'11px',color:'#e53e3e',marginTop:'4px'}}>Notes are required before forwarding to Director</div>}
                            </div>
                          )}
                          {!['m2_reviewed','d1_doc_approved','both_dirs_approved','payment_scheduled','paid'].includes(sel.status) && showRejectAll && (
                            <div style={{marginBottom:'12px',background:'#fff5f5',border:'1px solid #fed7d7',borderRadius:'8px',padding:'12px'}}>
                              <label style={{fontSize:'12px',color:'#c53030',fontWeight:'700',display:'block',marginBottom:'6px'}}>Reason for sending back (mandatory) *</label>
                              <textarea value={rejectAllReason} onChange={e=>setRejectAllReason(e.target.value)} placeholder="Explain why the case is being sent back for full correction..." style={{width:'100%',padding:'8px',border:'1px solid #fed7d7',borderRadius:'6px',fontSize:'13px',height:'60px',resize:'vertical',boxSizing:'border-box',marginBottom:'8px'}} />
                              <div style={{display:'flex',gap:'8px'}}>
                                <button onClick={rejectAllDocs} disabled={rejectingAll} style={{...btn,background:'#c53030',color:'white',fontSize:'13px'}}>{rejectingAll?'Sending...':'Confirm Send Back'}</button>
                                <button onClick={()=>{setShowRejectAll(false);setRejectAllReason('');}} style={{...btn,background:'#e2e8f0',color:'#4a5568',fontSize:'13px'}}>Cancel</button>
                              </div>
                            </div>
                          )}
                          <div style={{textAlign:'right',display:'flex',justifyContent:'flex-end',gap:'8px'}}>
                            {['m2_reviewed','d1_doc_approved','both_dirs_approved','payment_scheduled','paid'].includes(sel.status) ? (
                              <div style={{background:'#f0fff4',border:'1px solid #9ae6b4',borderRadius:'8px',padding:'10px 16px',color:'#276749',fontSize:'13px',fontWeight:'600',display:'inline-block'}}>
                                ✅ Forwarded to Director
                              </div>
                            ) : (
                              <>
                                {!showRejectAll && <button onClick={()=>setShowRejectAll(true)} style={{...btn,background:'#fff',color:'#c53030',border:'1px solid #fed7d7',fontSize:'13px'}}>↩ Reject All / Send Back</button>}
                                {!documents.every(d => ['m2_approved','d1_approved','d2_approved','d1_rejected','d2_rejected'].includes(d.status)) ? (
                                  <div style={{background:'#fff5f5',border:'1px solid #fed7d7',borderRadius:'8px',padding:'10px 16px',color:'#c53030',fontSize:'13px',fontWeight:'600',display:'inline-block'}}>
                                    ⚠️ Approve all documents before forwarding
                                  </div>
                                ) : (
                                  <button onClick={forwardToDirector} disabled={!m2ForwardNote.trim()} style={{...btn,background:m2ForwardNote.trim()?'#744210':'#a0aec0',color:'white',fontSize:'14px',padding:'10px 24px',cursor:m2ForwardNote.trim()?'pointer':'not-allowed'}}>
                                    ✅ Forward to Director
                                  </button>
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
      {showChangePw && (
        <ChangePassword token={localStorage.getItem('token')} onClose={() => setShowChangePw(false)} />
      )}
    </div>
  );
}

